<template>
  <main class="">
    <v-app>
      <v-form
        v-model="valid"
        class="create-a-timer layout__main-container"
        ref="catForm"
        @submit="submit"
      >
        <div class="create-a-timer__wrapper">
          <div class="create-a-timer__heading-wrapper">
            <h1
              class="text-size text-size-md create-a-timer__heading create-a-timer__heading--top"
            >
              {{ pageTitle }}
              <spring-spinner
                v-if="editTimer"
                v-wait:visible="'loading edit timer data'"
                :animation-duration="1500"
                :size="53"
                :color="'#b6bbff'"
                transition="fade"
                mode="out-in"
                :duration="1000"
                enter-active-class="enter-active"
              />
            </h1>
          </div>
          <div
            class="create-a-timer__preview create-a-timer__preview--top"
            :style="{
              backgroundColor: noBg ? 'transparent' : colorBg,
              backgroundImage: noBg ? null : 'none',
            }"
          >
            <v-wait for="loading timer preview">
              <spring-spinner
                :animation-duration="1500"
                :size="53"
                :color="'#b6bbff'"
                transition="fade"
                mode="out-in"
                :duration="1000"
                enter-active-class="enter-active"
                slot="waiting"
              />
              <img
                :src="timerPreview"
                alt="Timer preview"
                :class="{
                  'timer-preview--has-branding': freeAccount,
                }"
                class="timer-preview"
              />
            </v-wait>
          </div>
          <div class="create-a-timer__details">
            <h1 class="text-size text-size-md create-a-timer__heading">
              {{ pageTitle }}
            </h1>
            <spring-spinner
              v-if="editTimer"
              v-wait:visible="'loading edit timer data'"
              :animation-duration="1500"
              :size="53"
              :color="'#b6bbff'"
              transition="fade"
              mode="out-in"
              :duration="1000"
              enter-active-class="enter-active"
            />
            <div
              class="create-a-timer__padding-wrapper layout--margin-bottom-sm"
            >
              <label class="form-label" for="timerName"
                >1. Name your timer</label
              >
              <v-text-field
                ref="name"
                v-model="timerName"
                name="timerName"
                id="timerName"
                :rules="timerNameRules"
                required
                placeholder="e.g. 24 Hour Sale October"
                filled
              />
            </div>
            <Divider
              dark
              class="layout--margin-top-sm layout--margin-bottom-lg layout--hide-tablet-up"
            />
            <div
              class="create-a-timer__padding-wrapper layout--margin-bottom-md"
            >
              <fieldset>
                <legend class="form-label">2. When will your timer end?</legend>
                <v-menu
                  v-model="dateMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ attrs }">
                    <v-text-field
                      v-model="endDateFormatted"
                      ref="endDateMenu"
                      label="End date"
                      hint="MM/DD/YYYY format"
                      persistent-hint
                      prepend-icon="mdi-calendar"
                      placeholder="Select an end date"
                      :rules="endDateRules"
                      required
                      filled
                      v-bind="attrs"
                      @blur="updateDate(endDateFormatted)"
                      @change="getTimerPreviewImage"
                      @focus="handleFocusMenu($event, 'dateMenu')"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="endDate"
                    :show-current="false"
                    :min="today"
                    :light="true"
                    ref="endDatePicker"
                    color="primary"
                    @change="handleDateChange"
                  ></v-date-picker>
                </v-menu>

                <v-menu
                  ref="menu"
                  v-model="timeMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value="amPmTimeFormatted"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                  @input="getTimerPreviewImage"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="amPmTimeFormatted"
                      ref="amPmTime"
                      label="Time"
                      hint="03:49 PM format"
                      persistent-hint
                      prepend-icon="mdi-clock-outline"
                      required
                      :rules="timeRules"
                      filled
                      v-bind="attrs"
                      @blur="updateTime(amPmTimeFormatted)"
                      @change="getTimerPreviewImage"
                      @focus="handleFocusMenu($event, 'timeMenu')"
                    ></v-text-field>
                  </template>
                  <time-picker v-model="endTime" />
                  <!-- <v-time-picker
                    v-if="timeMenu"
                    v-model="endTime"
                    header-color="#05123d"
                    full-width
                    ampm-in-title
                    @click:minute="$refs.menu.save(endTime)"
                  ></v-time-picker> -->
                </v-menu>
                <!-- filter out suggested local timezone when searching -->
                <v-overflow-btn
                  class="searchable-input"
                  :items="timezones"
                  label="Time zone"
                  placeholder="Select time zone"
                  editable
                  filled
                  :filter="
                    (item, queryText, itemText) => {
                      return (
                        itemText
                          .toLocaleLowerCase()
                          .indexOf(queryText.toLocaleLowerCase()) > -1 &&
                        item.value[item.value.length - 1] !== '!'
                      );
                    }
                  "
                  :rules="timeZoneRules"
                  required
                  prepend-icon="mdi-earth"
                  v-model="selectedTimezone"
                  ref="timeZone"
                  item-value="value"
                  @change="getTimerPreviewImage"
                ></v-overflow-btn>
              </fieldset>
            </div>
            <Divider
              dark
              class="layout--margin-top-sm layout--margin-bottom-lg layout--hide-tablet-up"
            />
            <div class="create-a-timer__padding-wrapper">
              <label class="form-label" for="timerLanguage">3. Language</label>
              <v-overflow-btn
                class="searchable-input"
                name="timerLanguage"
                ref="timerLanguage"
                id="timerLanguage"
                :items="languages"
                label="Language"
                editable
                filled
                :rules="languageRules"
                required
                item-value="value"
                v-model="selectedLanguage"
                @change="getTimerPreviewImage"
              ></v-overflow-btn>
              <div
                class="layout--flex-start layout--margin-bottom-xs"
                id="localLanguage"
              >
                <v-checkbox
                  on-icon="mdi-check-box-outline"
                  :aria-describedby="freeAccount ? 'onlyPaid' : ''"
                  v-model="useLocalLanguage"
                  label="Use recipient's local language"
                  @change="getTimerPreviewImage"
                  :disabled="freeAccount"
                ></v-checkbox>
                <button
                  type="button"
                  @click="showHelpModal('language')"
                  class="button button--icon"
                >
                  <span class="sr-only"
                    >Learn about setting a timer to use the recipient's local
                    language.</span
                  >
                  <QuestionMarkIcon
                    class="icon icon--medium layout--margin-left-xs"
                  />
                </button>
              </div>
              <div
                v-if="freeAccount"
                class="layout--margin-top-none"
                id="onlyPaidLang"
              >
                <router-link class="link" :to="{ name: 'change plan' }">
                  Upgrade
                </router-link>
                to enable local language feature.
              </div>
            </div>
          </div>
          <div class="create-a-timer__design">
            <div
              class="create-a-timer__preview create-a-timer__preview--right"
              :style="{
                backgroundColor: noBg ? 'transparant' : colorBg,
                backgroundImage: noBg ? null : 'none',
              }"
            >
              <v-wait for="loading timer preview">
                <spring-spinner
                  :animation-duration="1500"
                  :size="53"
                  :color="'#b6bbff'"
                  transition="fade"
                  mode="out-in"
                  :duration="1000"
                  enter-active-class="enter-active"
                  slot="waiting"/>
                <img
                  :src="timerPreview"
                  alt="Timer preview"
                  :class="{
                    'timer-preview--has-branding': freeAccount,
                  }"
                  class="timer-preview"
              /></v-wait>
            </div>
            <Divider
              dark
              class="layout--margin-top-sm layout--margin-bottom-xs layout--hide-tablet-up"
            />
            <div class="create-a-timer__column-wrap">
              <div
                class="create-a-timer__column create-a-timer__padding-wrapper"
              >
                <label class="form-label" for="timeShape">4. Design</label>
                <div class="create-a-timer__selection-area">
                  <div class="create-a-timer__item-wrap">
                    <input
                      type="radio"
                      id="donuts"
                      v-model="timerShape"
                      name="timerShape"
                      value="3"
                      @change="getTimerPreviewImage"
                    />
                    <label
                      class="create-a-timer__button create-a-timer__button--gray"
                      for="donuts"
                      ><donutsImg /><span class="sr-only">Donuts</span></label
                    >
                  </div>
                  <div class="create-a-timer__item-wrap">
                    <input
                      type="radio"
                      id="metro"
                      v-model="timerShape"
                      name="timerShape"
                      value="1"
                      @change="getTimerPreviewImage"
                    />
                    <label
                      class="create-a-timer__button create-a-timer__button--gray"
                      for="metro"
                      ><metroImg /><span class="sr-only">Metro</span></label
                    >
                  </div>
                  <div class="create-a-timer__item-wrap">
                    <input
                      type="radio"
                      id="blocks"
                      v-model="timerShape"
                      name="timerShape"
                      value="2"
                      @change="getTimerPreviewImage"
                    />
                    <label
                      class="create-a-timer__button create-a-timer__button--gray"
                      for="blocks"
                      ><blocksImg /><span class="sr-only">Blocks</span></label
                    >
                  </div>
                  <div class="create-a-timer__item-wrap">
                    <input
                      type="radio"
                      id="capsule"
                      v-model="timerShape"
                      name="timerShape"
                      value="4"
                      @change="getTimerPreviewImage"
                    />
                    <label
                      class="create-a-timer__button create-a-timer__button--gray"
                      for="capsule"
                      ><capsuleImg /><span class="sr-only">Capsule</span></label
                    >
                  </div>
                </div>
                <div class="layout--flex-start layout--margin-top-xs">
                  <v-checkbox
                    on-icon="mdi-check-box-outline"
                    v-model="hideDays"
                    :hide-details="true"
                    label='Hide "Days"'
                    @change="getTimerPreviewImage"
                  ></v-checkbox>
                </div>
                <div
                  v-if="freeAccount"
                  class="layout--margin-top-md"
                  id="onlyPaidBrand"
                >
                  <router-link class="link" :to="{ name: 'change plan' }"
                    >Upgrade</router-link
                  >
                  to remove MotionMail branding.
                </div>
              </div>
              <Divider
                dark
                class="layout--margin-top-lg layout--margin-bottom-xs layout--hide-tablet-up"
              />
              <div
                class="create-a-timer__column create-a-timer__column--colors"
              >
                <fieldset>
                  <div class="create-a-timer__padding-wrapper">
                    <legend class="form-label">5. Colors</legend>
                    <div class="create-a-timer__colors">
                      <div class="create-a-timer__color">
                        <color-picker
                          v-on:color:update="selectColorSwatch"
                          :color="colorShape"
                          which-color="colorShape"
                          label="Design"
                        />
                      </div>

                      <div class="create-a-timer__color">
                        <color-picker
                          v-on:color:update="selectColorSwatch"
                          :color="colorText"
                          which-color="colorText"
                          label="Text"
                        />
                      </div>
                      <div
                        class="create-a-timer__color create-a-timer__color--backdrop"
                        :class="{
                          'create-a-timer__color--backdrop-transparent': noBg,
                        }"
                      >
                        <color-picker
                          v-on:color:update="selectColorSwatch"
                          :color="colorBg"
                          which-color="colorBg"
                          label="Backdrop"
                        />
                      </div>
                    </div>
                  </div>
                  <!--<Divider
                    dark
                    class="layout--margin-top-lg layout--margin-bottom-none layout--hide-tablet-up"
                  />-->
                  <div
                    class="create-a-timer__options create-a-timer__padding-wrapper layout--margin-top-md"
                  >
                    <div class="layout--flex-start">
                      <v-checkbox
                        on-icon="mdi-check-box-outline"
                        v-model="noBg"
                        @change="getTimerPreviewImage"
                        :hide-details="true"
                        label="No backdrop"
                      ></v-checkbox>
                      <button
                        type="button"
                        @click="showHelpModal('backdrop')"
                        class="button button--icon"
                      >
                        <span class="sr-only"
                          >Learn about setting no backdrop.</span
                        >
                        <QuestionMarkIcon
                          class="icon icon--medium layout--margin-left-xs"
                        />
                      </button>
                    </div>
                    <div
                      class="create-a-timer__colors layout--margin-top-xs"
                      v-show="noBg"
                    >
                      <div class="create-a-timer__color">
                        <color-picker
                          v-on:color:update="selectColorSwatch"
                          :color="colorMatte"
                          which-color="colorMatte"
                          label="Matte"
                          layout="horizontal"
                        />
                        <button
                          type="button"
                          @click="showHelpModal('matte-color')"
                          class="button button--icon"
                        >
                          <QuestionMarkIcon
                            class="icon icon--medium layout--margin-left-xs layout--margin-top-xs"
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </fieldset>
              </div>
              <Divider
                dark
                class="layout--margin-top-lg layout--margin-bottom-none layout--hide-tablet-up"
              />
              <div
                class="create-a-timer__column create-a-timer__padding-wrapper create-a-timer__padding-wrapper--right"
              >
                <fieldset>
                  <label for="fontSize" class="form-label">
                    6. Font
                  </label>
                  <v-overflow-btn
                    id="fontSize"
                    :items="fontSizes"
                    class="searchable-input"
                    label="Font size"
                    required
                    :rules="fontSizeRules"
                    v-model="restrictedFontSize"
                    ref="fontSize"
                    editable
                    filled
                    item-value="value"
                    @change="getTimerPreviewImage"
                    prefix="Size:"
                  ></v-overflow-btn>
                  <p
                    class="layout--margin-bottom-md"
                    v-show="restrictedFontSize >= 48"
                  >
                    Note: For sizes 48px and up, the timer preview window may
                    not display the full size of your timer.
                  </p>
                  <div
                    class="create-a-timer__selection-area create-a-timer__selection-area--fonts"
                  >
                    <div class="create-a-timer__item-wrap">
                      <input
                        type="radio"
                        name="fontFamilyRecommended"
                        id="fontFamilyArial"
                        v-model="selectedFont"
                        value="Arial"
                        @change="getTimerPreviewImage"
                      />
                      <label
                        class="create-a-timer__button"
                        for="fontFamilyArial"
                        ><font-arial style="width: 33px; height: 12px;" /><span
                          class="sr-only"
                          >Arial</span
                        ></label
                      >
                    </div>
                    <div class="create-a-timer__item-wrap">
                      <input
                        type="radio"
                        name="fontFamilyRecommended"
                        id="fontRoboto"
                        value="Roboto"
                        v-model="selectedFont"
                        @change="getTimerPreviewImage"
                      />
                      <label class="create-a-timer__button" for="fontRoboto"
                        ><font-roboto style="width: 54px; height: 13px;" /><span
                          class="sr-only"
                          >Robot</span
                        ></label
                      >
                    </div>
                    <div class="create-a-timer__item-wrap">
                      <input
                        type="radio"
                        name="fontFamilyRecommended"
                        id="fontFamilyImpact"
                        value="Impact"
                        v-model="selectedFont"
                        @change="getTimerPreviewImage"
                      />
                      <label
                        class="create-a-timer__button"
                        for="fontFamilyImpact"
                        ><font-impact style="width: 51px; height: 16px;" /><span
                          class="sr-only"
                          >Impact</span
                        ></label
                      >
                    </div>
                    <div class="create-a-timer__item-wrap">
                      <input
                        type="radio"
                        name="fontFamilyRecommended"
                        id="fontFamilyPlayfair"
                        value="Playfair Display"
                        v-model="selectedFont"
                        @change="getTimerPreviewImage"
                      />
                      <label
                        class="create-a-timer__button"
                        for="fontFamilyPlayfair"
                        ><font-playfair
                          style="width: 62px; height: 17px;"
                        /><span class="sr-only">Playfair</span></label
                      >
                    </div>
                    <div class="create-a-timer__item-wrap">
                      <input
                        type="radio"
                        name="fontFamilyRecommended"
                        id="fontFamilyRubik"
                        value="Rubik"
                        v-model="selectedFont"
                        @change="getTimerPreviewImage"
                      />
                      <label
                        class="create-a-timer__button"
                        for="fontFamilyRubik"
                        ><font-rubik style="width: 47px; height: 15px;" /><span
                          class="sr-only"
                          >Rubik</span
                        ></label
                      >
                    </div>
                    <div class="create-a-timer__item-wrap">
                      <input
                        type="radio"
                        name="fontFamilyRecommended"
                        id="fontFamilySanchez"
                        value="Sanchez"
                        v-model="selectedFont"
                        @change="getTimerPreviewImage"
                      />
                      <label
                        class="create-a-timer__button"
                        for="fontFamilySanchez"
                        ><font-sanchez
                          style="width: 68px; height: 14px;"
                        /><span class="sr-only">Sanchez</span></label
                      >
                    </div>
                  </div>
                  <v-overflow-btn
                    id="fontOptions"
                    :items="fontFamilies"
                    label="More font options"
                    class="searchable-input"
                    v-model="selectedFont"
                    editable
                    filled
                    item-value="value"
                    @change="getTimerPreviewImage"
                    ref="fontSelect"
                    v-click-outside="
                      () => {
                        $refs && $refs.fontSelect && $refs.fontSelect.blur();
                      }
                    "
                  >
                    <template slot="item" slot-scope="data">
                      <div class="create-a-timer__font-options">
                        <span>{{ data.item.text }}</span>
                        <component :is="getFontPreview(data.item.text)" />
                      </div>
                    </template>
                  </v-overflow-btn>
                </fieldset>
              </div>
            </div>
          </div>
        </div>
        <div
          class="layout--flex-end create-a-timer__submit-button-wrapper layout--padding-top-lg"
        >
          <LoadingButton
            big
            class="create-a-timer__submit-button"
            :event="submit"
            :loading="$wait.is('updating timer') || $wait.is('creating timer')"
            :doneLoading="false"
            label="Save and continue"
          />
        </div>
      </v-form>
    </v-app>
    <modal name="language" class="modal-window" :width="725" :adaptive="true">
      <button
        type="button"
        @click="$modal.hide('language')"
        class="button button--close"
      >
        <IconClose class="icon icon--medium-large" />
      </button>
      <div class="layout--text-left modal-window__wrap">
        <h3 class="modal-window__title">Dynamic Local Language</h3>
        <div class="modal-window__form-wrap">
          <div class="layout--margin-right-xl">
            <IconLanguage style="width: 86px; height: 86px;" />
          </div>
          Using this feature, the timer label language dynamically adapts to the
          local language (i.e. the browser language of the email recipient).
        </div>
      </div>
    </modal>
    <modal
      name="backdrop"
      class="modal-window"
      :width="725"
      :height="590"
      :adaptive="true"
    >
      <button
        type="button"
        @click="$modal.hide('backdrop')"
        class="button button--close"
      >
        <IconClose class="icon icon--medium-large" />
      </button>
      <div class="layout--text-left modal-window__wrap">
        <h3 class="modal-window__title">Using the “No Backdrop” Option</h3>
        <div class="modal-window__form-wrap layout--margin-bottom-sm">
          This option allows your email's background to show through the timer
          design. Below is an example comparison.
        </div>
        <div class="layout--flex-start">
          <div
            style="max-width: 50%"
            class="layout--padding-right-xs layout--text-center"
          >
            <img
              src="../../assets/images/modal-no-backdrop-transparent@2x.png"
              alt="5 hours"
              class="layout--margin-bottom-sm"
            />
            <h4 class="text-size-sm layout--margin-bottom-xs">No Backdrop</h4>
            <p class="layout--padding-left-md layout--padding-right-md">
              Your email's background shows through the timer design.
            </p>
          </div>
          <div
            style="max-width: 50%"
            class="layout--padding-left-xs layout--text-center"
          >
            <img
              src="../../assets/images/modal-no-backdrop@2x.png"
              alt="5 hours"
              class="layout--margin-bottom-sm"
            />
            <h4 class="text-size-sm layout--margin-bottom-xs">With Backdrop</h4>
            <p class="layout--padding-left-md layout--padding-right-md">
              Your timer uses a solid color behind it.
            </p>
          </div>
        </div>
      </div>
    </modal>
    <modal
      name="matte-color"
      class="modal-window"
      :width="725"
      :height="620"
      :adaptive="true"
    >
      <button
        type="button"
        @click="$modal.hide('matte-color')"
        class="button button--close"
      >
        <IconClose class="icon icon--medium-large" />
      </button>
      <div class="layout--text-left modal-window__wrap">
        <h3 class="modal-window__title">Selecting a Matte Color</h3>
        <div class="modal-window__form-wrap layout--margin-bottom-sm">
          When using the “No backdrop” option, it’s a good idea to select a
          matte color which matches the background color of your email.
        </div>
        <div class="layout--flex-start">
          <div
            style="max-width: 50%"
            class="layout--padding-right-xs layout--text-center"
          >
            <img
              src="../../assets/images/modal-matte-color-without@2x.png"
              alt="5 hours"
              class="layout--margin-bottom-sm"
            />
            <h4 class="text-size-sm layout--margin-bottom-xs">
              Without a matte color
            </h4>
            <p class="layout--padding-left-md layout--padding-right-md">
              Notice that without a matte color the edges of the timer appear
              ragged.
            </p>
          </div>
          <div
            style="max-width: 50%"
            class="layout--padding-left-xs layout--text-center"
          >
            <img
              src="../../assets/images/modal-matte-color-with@2x.png"
              alt="5 hours"
              class="layout--margin-bottom-sm"
            />
            <h4 class="text-size-sm layout--margin-bottom-xs">
              With a matte color
            </h4>
            <p class="layout--padding-left-md layout--padding-right-md">
              Get smooth edges on your timer by selecting a matte color which
              matches your email's background color.
            </p>
          </div>
        </div>
      </div>
    </modal>
  </main>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import { mapWaitingActions } from "vue-wait";
import ColorPicker from "./ColorPicker";
import LoadingButton from "../../components/LoadingButton";
import { hexToRgb, rgbToHex } from "../../helpers/helpers";

/**
 * icons
 */
import donutsImg from "../../assets/icons/timerDesign-Donuts.svg";
import capsuleImg from "../../assets/icons/timerDesign-Capsule.svg";
import blocksImg from "../../assets/icons/timerDesign-Blocks.svg";
import metroImg from "../../assets/icons/timerDesign-Metro.svg";
import fontArial from "../../assets/icons/iconCreateTimer-Arial.svg";
import fontImpact from "../../assets/icons/iconCreateTimer-Impact.svg";
import QuestionMarkIcon from "../../assets/icons/iconQuestionMark.svg";
import IconClose from "../../assets/icons/iconCloseX.svg";
import IconLanguage from "../../assets/icons/iconDynamicLocalLanguage.svg";
import fontPlayfair from "../../assets/icons/iconCreateTimer-Playfair.svg";
import fontRubik from "../../assets/icons/iconCreateTimer-Rubik.svg";
import fontSanchez from "../../assets/icons/iconCreateTimer-Sanchez.svg";
import fontRoboto from "../../assets/icons/iconCreateTimer-Roboto.svg";
import fontAgency from "../../assets/icons/iconCreateTimer-AgencyFB.svg";
import fontArsenal from "../../assets/icons/iconCreateTimer-Arsenal.svg";
import fontComic from "../../assets/icons/iconCreateTimer-ComicSans.svg";
import fontCourier from "../../assets/icons/iconCreateTimer-CourierNew.svg";
import fontCurlz from "../../assets/icons/iconCreateTimer-CurlzPro.svg";
import fontGeorgia from "../../assets/icons/iconCreateTimer-Georgia.svg";
import fontLucida from "../../assets/icons/iconCreateTimer-Lucida.svg";
import fontMontserrat from "../../assets/icons/iconCreateTimer-Montserrat.svg";
import fontPalatino from "../../assets/icons/iconCreateTimer-Palatino.svg";
import fontPlayfairPrev from "../../assets/icons/iconCreateTimer-PlayfairPrev.svg";
import fontPlayfairBlack from "../../assets/icons/iconCreateTimer-PlayfairBlack.svg";
import fontQuartz from "../../assets/icons/iconCreateTimer-Quartz.svg";
import fontRobotoPrev from "../../assets/icons/iconCreateTimer-RobotoPrev.svg";
import fontRubikPrev from "../../assets/icons/iconCreateTimer-RubikPrev.svg";
import fontRubikBlack from "../../assets/icons/iconCreateTimer-RubikBlack.svg";
import fontRubikLight from "../../assets/icons/iconCreateTimer-RubikLight.svg";
import fontRubikMedium from "../../assets/icons/iconCreateTimer-RubikMedium.svg";
import fontSanchezPrev from "../../assets/icons/iconCreateTimer-SanchezPrev.svg";
import fontSansSerif from "../../assets/icons/iconCreateTimer-SansSerif.svg";
import fontScript from "../../assets/icons/iconCreateTimer-Script.svg";
import fontStencil from "../../assets/icons/iconCreateTimer-Stencil.svg";
import fontTahoma from "../../assets/icons/iconCreateTimer-Tahoma.svg";
import fontTimes from "../../assets/icons/iconCreateTimer-Times.svg";
import fontTrebuchet from "../../assets/icons/iconCreateTimer-Trebuchet.svg";
import fontVerdana from "../../assets/icons/iconCreateTimer-Verdana.svg";

/**
 * vue components
 */
import Divider from "../../components/Divider";
import TimePicker from "../../components/TimePicker";

const leadingZeroes = value => (value.length < 2 ? "0" + value : value);

export default {
  name: "CreateATimer",
  data() {
    return {
      userTimeOffset: "",
      timeMenu: false,
      valid: false,
      timerName: "",
      timerNameRules: [
        v => !!v || "Give it a name.  It will help you to identify it later.",
      ],
      endDateRules: [v => !!v || "Select an end day for your countdown."],
      timeRules: [v => !!v || "Select an end time for your countdown."],
      timeZoneRules: [v => !!v || "Select a time zone for your countdown."],
      languageRules: [v => !!v || "Please select a language"],
      fontSizeRules: [v => !!v || "Please select a font size for your timer"],
      maxFontSize: {
        withDays: 60,
        withoutDays: 60,
      },
      endDate: null,
      endDateFormatted: null,
      endTime: "00:00",
      amPmTimeFormatted: "12:00 AM",
      selectedLanguage: "en",
      useLocalLanguage: false,
      hideDays: false,
      noBg: false,
      selectedTimezone: null,
      timerShape: "3",
      colorShape: "#000000",
      selectedFont: "Arial",
      selectedFontSize: 36,
      colorText: "#b8b8b8",
      colorBg: "#ffffff",
      colorMatte: "#f5f5f5",
      timerPreview: null,
      editTimerData: null,
      dateMenu: false,
    };
  },
  mounted() {
    // select name your timer input field on load
    this.$refs.name.focus();

    // store UTC time offset of user's device in hours
    this.userTimeOffset = new Date().getTimezoneOffset() / 60;
    this.getTimezoneList();
    // get latest data for this timer from the API and set values in form to it
    if (this.editTimer && !this.editTimerData) {
      this.getTimerInfo(this.timerId).then(result => {
        this.editTimerData = result.widget;
        this.timerName = this.editTimerData.name;
        // extract date from timestamp
        this.endDate = this.editTimerData.endDateTime.split("T")[0];
        // extract time from timestamp
        this.endTime = this.editTimerData.endDateTime
          .split("T")[1]
          .substring(0, 5);
        this.selectedTimezone = this.editTimerData.endTimeZoneInfo;
        this.selectedLanguage = this.editTimerData.languageCode;
        this.useLocalLanguage = this.editTimerData.shouldUseDynamicLocal;
        this.timerShape = this.editTimerData.timerStyle.toString();
        this.colorShape = this.convertRgbToHex(this.editTimerData.boxColor);
        this.colorText = this.convertRgbToHex(this.editTimerData.textColor);
        this.noBg = this.editTimerData.backgroundTransparent;
        if (this.noBg) {
          this.colorMatte = this.convertRgbToHex(this.editTimerData.backgroundColor);
        } else {
          this.colorBg = this.convertRgbToHex(this.editTimerData.backgroundColor);
        }
        this.hideDays = !this.editTimerData.includeDays;
        this.selectedFont = this.editTimerData.fontFamily;
        this.selectedFontSize = this.editTimerData.fontSize;
        this.getTimerPreviewImage();
      });
    } else {
      const [month, date, year] = new Date()
        .toLocaleDateString("en-US")
        .split("/")
        .map(d => leadingZeroes(d));
      this.endDate = `${year}-${month}-${date}`;
      this.getTimerPreviewImage();
    }
  },
  methods: {
    ...mapActions("timers", ["getTimezoneList", "getTimer"]),
    ...mapWaitingActions("timers", {
      getTimerPreview: "loading timer preview",
      getTimerInfo: "loading edit timer data",
      createTimer: "creating timer",
      updateTimer: "updating timer",
    }),
    ...mapMutations("session", ["addValidationAlert", "clearValidationAlerts"]),
    showHelpModal(modalName) {
      this.$modal.show(modalName);
    },
    handleFocusMenu(event, menuKey) {
      if (this.isMobile && !this[menuKey]) {
        this.$nextTick(() => {
          event.target.blur();
        });
      }
      if (this.isMobile && this[menuKey]) return;

      // Fix for initial focus not taking. Something seems busted with vuetify's open-on-focus
      this.$nextTick(() => {
        setTimeout(() => {
          this[menuKey] = true;
        }, 200);
      });
    },
    selectColorSwatch({ whichSwatch, color }) {
      this[whichSwatch] = color;
      this.getTimerPreviewImage();
    },
    convertColorValue(hex) {
      let rgb = hexToRgb(hex);
      return `${rgb.r}.${rgb.g}.${rgb.b}`;
    },
    convertRgbToHex(rgb) {
      // split 0.0.0 rgb string to individual int values and convert
      const [r, g, b] = rgb.split(".").map(s => parseInt(s));
      return rgbToHex(r, g, b);
    },
    handleDateChange() {
      this.dateMenu = false;
      this.getTimerPreviewImage();
    },
    getTimerPreviewImage() {
      // if date, time, and timezone have not been set, set temp values
      let endDate;
      let endTime;
      let endTimeZone;
      if (!this.endDate || !this.endTime || !this.selectedTimezone) {
        endDate = "2020-01-01";
        endTime = "00:00:00";
        endTimeZone =
          "Pacific+Standard+Time;-480;(UTC-08:00)+Pacific+Time+(US+&+Canada);Pacific+Standard+Time;Pacific+Daylight+Time;[01:01:0001;12:31:2006;60;[0;02:00:00;4;1;0;];[0;02:00:00;10;5;0;];][01:01:2007;12:31:9999;60;[0;02:00:00;3;2;0;];[0;02:00:00;11;1;0;];];";
      } else {
        endDate = this.endDate;
        endTime = this.endTime;
        if (this.selectedTimezone[this.selectedTimezone.length - 1] === "!") {
          endTimeZone = this.selectedTimezone.slice(0, -1);
        } else {
          endTimeZone = this.selectedTimezone;
        }
      }

      let timerDetails = {
        scaleFactor: 2,
        active: true,
        archived: false,
        name: this.timerName, // ""
        timerStyle: parseInt(this.timerShape), // 1
        endDateTime: endDate + "T" + endTime, // 2020-12-08T00:59:00 <-- make sure to url encode this
        endTimeZoneInfo: endTimeZone, // Pacific%2BStandard%2BTime%3B-480%3B%28UTC-08%3A00%29%2BPacific%2BTime%2B%28US%2B%26%2BCanada%29%3BPacific%2BStandard%2BTime%3BPacific%2BDaylight%2BTime%3B%5B01%3A01%3A0001%3B12%3A31%3A2006%3B60%3B%5B0%3B02%3A00%3A00%3B4%3B1%3B0%3B%5D%3B%5B0%3B02%3A00%3A00%3B10%3B5%3B0%3B%5D%3B%5D%5B01%3A01%3A2007%3B12%3A31%3A9999%3B60%3B%5B0%3B02%3A00%3A00%3B3%3B2%3B0%3B%5D%3B%5B0%3B02%3A00%3A00%3B11%3B1%3B0%3B%5D%3B%5D%3B
        backgroundColor: this.noBg
          ? this.convertColorValue(this.colorMatte)
          : this.convertColorValue(this.colorBg), // 241.241.241
        backgroundTransparent: this.noBg, // false
        textColor: this.convertColorValue(this.colorText), // 153.153.153
        boxColor: this.convertColorValue(this.colorShape), // 0.0.0
        fontFamily: this.selectedFont, // Arial
        fontSize: this.restrictedFontSize, // 28
        languageCode: this.selectedLanguage, // en
        shouldUseDynamicLocal: this.useLocalLanguage, // false
        includeDays: !this.hideDays, // true
        discriminator: "CountdownTimer",
      };
      return this.getTimerPreview(timerDetails)
        .then(result => {
          const fileURL = window.URL.createObjectURL(new Blob([result.data]));
          return (this.timerPreview = fileURL);
        })
        .catch(error => {
          this.timerPreview = "";
        });
    },
    submit(e) {
      const isLoading = this.$wait.is('updating timer') || this.$wait.is('creating timer');
      // returns valid or not
      if (!isLoading && this.$refs.catForm.validate()) {
        // if date, time, and timezone have not been set, set temp values
        let endDate;
        let endTime;
        let endTimeZone;
        if (!this.endDate || !this.endTime || !this.selectedTimezone) {
          endDate = "2020-01-01";
          endTime = "00:00:00";
          endTimeZone =
            "Pacific+Standard+Time;-480;(UTC-08:00)+Pacific+Time+(US+&+Canada);Pacific+Standard+Time;Pacific+Daylight+Time;[01:01:0001;12:31:2006;60;[0;02:00:00;4;1;0;];[0;02:00:00;10;5;0;];][01:01:2007;12:31:9999;60;[0;02:00:00;3;2;0;];[0;02:00:00;11;1;0;];];";
        } else {
          endDate = this.endDate;
          endTime = this.endTime;
          // scrub fake character off duplicate user time zone
          if (this.selectedTimezone[this.selectedTimezone.length - 1] === "!") {
            let cleanTimezone = this.selectedTimezone.slice(0, -1);
            endTimeZone = cleanTimezone;
          } else {
            endTimeZone = this.selectedTimezone;
          }
        }

        let widget = {
          name: this.timerName,
          timerStyle: parseInt(this.timerShape), // 1
          endDateTime: endDate + "T" + endTime + ":00", // 2020-12-08T00:59:00 <-- make sure to url encode this
          endTimeZoneInfo: endTimeZone, // Pacific%2BStandard%2BTime%3B-480%3B%28UTC-08%3A00%29%2BPacific%2BTime%2B%28US%2B%26%2BCanada%29%3BPacific%2BStandard%2BTime%3BPacific%2BDaylight%2BTime%3B%5B01%3A01%3A0001%3B12%3A31%3A2006%3B60%3B%5B0%3B02%3A00%3A00%3B4%3B1%3B0%3B%5D%3B%5B0%3B02%3A00%3A00%3B10%3B5%3B0%3B%5D%3B%5D%5B01%3A01%3A2007%3B12%3A31%3A9999%3B60%3B%5B0%3B02%3A00%3A00%3B3%3B2%3B0%3B%5D%3B%5B0%3B02%3A00%3A00%3B11%3B1%3B0%3B%5D%3B%5D%3B
          backgroundColor: this.noBg
            ? this.convertColorValue(this.colorMatte)
            : this.convertColorValue(this.colorBg), // 241.241.241
          backgroundTransparent: this.noBg, // false
          textColor: this.convertColorValue(this.colorText), // 153.153.153
          boxColor: this.convertColorValue(this.colorShape), // 0.0.0
          fontFamily: this.selectedFont, // Arial
          fontSize: this.restrictedFontSize, // 28
          languageCode: this.selectedLanguage, // en
          shouldUseDynamicLocal: this.useLocalLanguage, // false
          includeDays: !this.hideDays, // true
          active: true,
          archived: false,
          discriminator: "CountdownTimer",
        };
        // if editing timer, update it. If new timer, create new timer
        if (this.editTimer) {
          widget.id = this.timerId;
          // update timer, then send user to view updated timer on timer detail page
          this.updateTimer(widget).then(result => {
            this.$router.push({
              name: "timer details",
              query: { timerId: result.widget.id },
            });
          });
        } else {
          // create timer, then send user to view new timer on timer detail page
          this.createTimer(widget).then(result => {
            this.$router.push({
              name: "timer details",
              query: { timerId: result.widget.id },
            });
          });
        }
      } else {
        // go to first error
        this.setupValidationAlert();
        let firstError = document.querySelector(".error--text");
        window.scrollTo(0, 0);
      }
    },
    setupValidationAlert() {
      this.clearValidationAlerts();
      [
        {
          name: "Timer Name",
          vNode: this.$refs.name,
        },
        {
          name: "End Date",
          vNode: this.$refs.endDate,
        },
        {
          name: "End Time",
          vNode: this.$refs.amPmTime,
        },
        {
          name: "Time Zone",
          vNode: this.$refs.timeZone,
        },
        {
          name: "Language",
          vNode: this.$refs.timerLanguage,
        },
        {
          name: "Font Size",
          vNode: this.$refs.fontSize,
        },
      ].forEach(item => {
        if (!item.vNode.valid) {
          this.addValidationAlert({
            name: item.name,
            top:
              item.vNode.$el.getBoundingClientRect().top + window.scrollY - 25,
            valid: item.vNode.valid,
          });
        }
      });
    },
    getFontPreview(fontName) {
      switch (fontName) {
        case "Agency FB":
          return "fontAgency";
          break;
        case "Arsenal":
          return "fontArsenal";
          break;
        case "Comic Sans":
          return "fontComic";
          break;
        case "Courier New":
          return "fontCourier";
          break;
        case "Curlz MT":
          return "fontCurlz";
          break;
        case "Georgia":
          return "fontGeorgia";
          break;
        case "Lucida Console":
          return "fontLucida";
          break;
        case "Montserrat":
          return "fontMontserrat";
          break;
        case "Palatino Linotype":
          return "fontPalatino";
          break;
        case "Playfair Display":
          return "fontPlayfairPrev";
          break;
        case "Playfair Display Black":
          return "fontPlayfairBlack";
          break;
        case "Quartz":
          return "fontQuartz";
          break;
        case "Roboto Regular":
          return "fontRobotoPrev";
          break;
        case "Rubik":
          return "fontRubikPrev";
          break;
        case "Rubik Black":
          return "fontRubikBlack";
          break;
        case "Rubik Light":
          return "fontRubikLight";
          break;
        case "Rubik Medium":
          return "fontRubikMedium";
          break;
        case "Sanchez":
          return "fontSanchezPrev";
          break;
        case "Sans Serif":
          return "fontSansSerif";
          break;
        case "Script":
          return "fontScript";
          break;
        case "Stencil":
          return "fontStencil";
          break;
        case "Tahoma":
          return "fontTahoma";
          break;
        case "Times":
          return "fontTimes";
          break;
        case "Trebuchet":
          return "fontTrebuchet";
          break;
        case "Verdana":
          return "fontVerdana";
          break;
        default:
          return "donutsImg";
          break;
      }
    },
    updateDate(date) {
      try {
        this.endDate = this.parseDate(date);
      } catch (err) {
        console.error(err);
        this.endDateFormatted = this.formatDate(this.endDate);
      }
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${month}/${day}/${year}`;
    },
    parseDate(date) {
      const regex = new RegExp("^[0-1]?[0-9]/[0-3]?[0-9]/[0-9]{4}$");
      if (!regex.test(date) || isNaN(new Date(date).getTime()))
        throw "could not parse date";
      if (!date) return null;

      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    updateTime(time) {
      try {
        this.amPmTime = this.formatTime(time);
      } catch (err) {
        console.log(err);
        this.amPmTimeFormatted = this.amPmTime;
      }
    },
    formatTime(time) {
      const regex = new RegExp(
        "^(0?[1-9]|1[0-2]):([0-5][0-9])\\s?(am|pm)$",
        "i"
      );
      if (!regex.test(time)) throw "invalid time input";

      const [full, hour, minutes, meridian] = time.match(regex);
      return `${hour.padStart(2, "0")}:${minutes} ${meridian.toUpperCase()}`;
    },
  },
  watch: {
    // if someone tries to change the bg color when no backdrop is selected, we auto unselect it
    colorBg(x, y) {
      if (this.noBg) {
        this.noBg = false;
      }
    },
    // watch for changes to values not in v-form and get new timer preview
    valueChanged() {},
    endDate(val) {
      this.endDateFormatted = this.formatDate(val);
    },
    endTime(val) {
      this.amPmTimeFormatted = this.amPmTime;
    },
  },
  computed: {
    ...mapGetters("timers", ["timezones", "languages", "fontFamilies"]),
    ...mapGetters("session", ["token"]),
    ...mapGetters("account", ["subscription"]),
    // the UTC offset of the user's device in "UTC+00:00" format
    utcOffset: function() {
      const hours = Math.floor(Math.abs(this.userTimeOffset)).toString();
      const minutes = ((Math.abs(this.userTimeOffset) % 1) * 60).toString();
      let symbol = "-";
      if (this.userTimeOffset < 0) {
        symbol = "+";
      }
      return `UTC${symbol}${leadingZeroes(hours)}:${leadingZeroes(minutes)}`;
    },
    // displays as 12 hour time to the user but stores as 24 hour time
    amPmTime: {
      get: function() {
        const [hours, minutes] = this.endTime.split(":").map(t => parseInt(t));
        let hours12 = hours;
        let minutes12 = minutes;
        let amPm = "AM";
        if (hours > 12) {
          hours12 = hours - 12;
        }
        if (hours >= 12) {
          amPm = "PM";
        }
        if (hours <= 12) {
          hours12 = hours;
        }
        if (hours === 0) {
          hours12 = 12;
        }
        hours12 = hours12.toString();
        minutes12 = minutes12.toString();

        return `${leadingZeroes(hours12)}:${leadingZeroes(minutes12)} ${amPm}`;
      },
      set: function(newValue) {
        const [hours, minutes, amPm] = newValue
          .split(/[: ]/)
          .map(t => (parseInt(t) ? parseInt(t) : t));
        let hours24 = hours;
        let minutes24 = minutes;
        if (amPm === "PM" && hours < 12) {
          hours24 = hours + 12;
        }
        if (amPm === "AM" && hours === 12) {
          hours24 = 0;
        }
        hours24 = hours24.toString();
        minutes24 = minutes24.toString();

        this.endTime = `${leadingZeroes(hours24)}:${leadingZeroes(minutes24)}`;
        this.amPmTimeFormatted = newValue;
      },
    },
    // restricts font size to 48 if days are shown
    restrictedFontSize: {
      get: function() {
        if (
          !this.hideDays &&
          this.selectedFontSize > this.maxFontSize.withDays
        ) {
          return this.maxFontSize.withDays;
        }
        return this.selectedFontSize;
      },
      set: function(newValue) {
        if (
          !this.hideDays &&
          this.selectedFontSize > this.maxFontSize.withDays
        ) {
          this.selectedFontSize = this.maxFontSize.withDays;
        } else {
          this.selectedFontSize = newValue;
        }
      },
    },
    // returns the timerId from the query string if there is one
    timerId() {
      if (this.$route.query.timerId) {
        return parseInt(this.$route.query.timerId);
      }
      return null;
    },
    // returns true if there is a query string for timerId
    editTimer() {
      if (this.$route.query.timerId) {
        return true;
      }
      return false;
    },
    // different page title depending on if it's edit or create
    pageTitle() {
      if (this.editTimer) {
        return "Edit Timer";
      }
      return "Create New Timer";
    },
    // used to watch if any values not in v-form change
    valueChanged() {
      return `${this.timerShape}${this.selectedFont}${this.selectedFontSize}${this.colorShape}${this.colorText}${this.hideDays}${this.selectedLanguage}${this.useLocalLanguage}${this.colorBg}`;
    },
    today() {
      let date = new Date();
      let year = new Intl.DateTimeFormat("en", { year: "numeric" }).format(
        date
      );
      let month = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(
        date
      );
      let day = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(date);
      return `${year}-${month}-${day}`;
    },
    fontSizes() {
      const start = 16;
      let fontSizes = [];
      let maxSize = 0;

      // max font size is less with days displayed than without days
      if (this.hideDays) {
        maxSize = this.maxFontSize.withoutDays;
      } else {
        maxSize = this.maxFontSize.withDays;
      }

      for (var i = start; i <= maxSize; i = i + 2) {
        fontSizes.push({
          value: i,
          text: i + "px",
        });
      }
      return fontSizes;
    },
    freeAccount() {
      return this.subscription.subscriptionType === 0;
    },
    isMobile() {
      return this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs;
    },
  },
  components: {
    IconLanguage,
    IconClose,
    LoadingButton,
    ColorPicker,
    donutsImg,
    metroImg,
    capsuleImg,
    blocksImg,
    fontArial,
    fontImpact,
    fontPlayfair,
    fontRubik,
    fontSanchez,
    fontRoboto,
    fontAgency,
    fontArsenal,
    fontComic,
    fontCourier,
    fontCurlz,
    fontGeorgia,
    fontLucida,
    fontMontserrat,
    fontPalatino,
    fontPlayfairPrev,
    fontPlayfairBlack,
    fontQuartz,
    fontRobotoPrev,
    fontRubikPrev,
    fontRubikBlack,
    fontRubikLight,
    fontRubikMedium,
    fontSanchezPrev,
    fontSansSerif,
    fontScript,
    fontStencil,
    fontTahoma,
    fontTimes,
    fontTrebuchet,
    fontVerdana,
    Divider,
    QuestionMarkIcon,
    TimePicker,
  },
};
</script>

<style lang="scss">
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

// scale 2x retina image
.timer-preview {
  transform: scale(0.9);
  @include for-size(tablet-up) {
    transform: scale(0.57);
  }
  @include for-size(tablet-landscape-up) {
    transform: scale(0.5, 0.5);
  }
  &--has-branding {
    transform: scale(0.9) translateY(6%);
    @include for-size(tablet-up) {
      transform: scale(0.57) translateY(6%);
    }
    @include for-size(tablet-landscape-up) {
      transform: scale(0.5, 0.5) translateY(6%);
    }
  }
}

#app .input-group__error a {
  color: $purple;
}

#app .v-icon.mdi-checkbox-blank-outline.theme--light {
  color: #000000;
}

#app
  .theme--light.v-input--selection-controls.v-input--is-disabled:not(.v-input--indeterminate)
  .v-icon {
  color: #707070 !important;
}

#localLanguage .v-input__slot {
  margin-bottom: 0;
}

#localLanguage .v-messages {
  line-height: 0;
  font-size: 0;
  position: absolute;
}

#app .menu__color-panel #timerLanguage,
[for="fontOptions"],
#fontOptions,
#app .v-input:not(.error--text) input[placeholder="Select time zone"],
input[placeholder="Select time zone"],
#fontSize,
#app .v-text-field__prefix {
  margin-top: 0.5em;
  margin-left: 0 !important;
  padding-left: 0 !important;
  padding-right: 0;
}

#app .v-text-field__prefix {
  margin-right: 0.25em;
}

[for="timerLanguage"] + .v-input .v-input__control .v-input__slot,
[for="timerLanguage"] + .v-input .v-input__control .v-text-field__details,
[for="fontSize"] + .v-input .v-input__control .v-input__slot,
[for="fontSize"] + .v-input .v-input__control .v-text-field__details {
  margin-bottom: 0;
}

#app .v-input.theme--light.v-input--selection-controls.v-input--checkbox {
  margin-top: 0;
}

#app .v-list .v-divider {
  margin-bottom: 0.75em;
}

#app .v-picker--full-width .v-time-picker-clock__container {
  background-color: $light-blue;
}

#app .v-picker__title.primary {
  display: none;
}

// date picker circle color
#app .v-date-picker-table.v-date-picker-table--date button.v-btn--active {
  background-color: #7cf1c3 !important;
}

// date picker circle text color
#app .v-date-picker-table.v-date-picker-table--date button.v-btn {
  color: $black;
}

#app .v-time-picker-clock__item--active,
#app .v-time-picker-clock__hand,
#app .v-time-picker-clock__hand:after {
  background-color: $light-green !important;
  color: $black;
  border-color: $light-green;
  border-width: 7px;
  font-size: $font-size-sm;
  font-weight: bold;
}

#app .v-time-picker-title__time > .v-picker__title__btn,
#app .v-time-picker-title__time > .v-picker__title__btn--active,
#app
  .v-time-picker-title__time
  > .v-picker__title__btn:not(.v-picker__title__btn--active) {
  font-size: 3.4em;
  opacity: 1;
  font-weight: 600;
}

#app .v-time-picker-title__ampm > .v-picker__title__btn {
  font-size: 1em;
  font-weight: bold;
}

#app .v-picker__title__btn:not(.v-picker__title__btn--active) {
  opacity: 1;
  font-weight: normal;
}

#app .v-application--is-ltr .v-time-picker-title__ampm {
  margin-bottom: 14px;
}

#app
  .v-application--is-ltr
  .v-time-picker-title__ampm
  .v-picker__title__btn:first-child {
  margin-bottom: 0.4em;
}

#app .theme--light.v-time-picker-clock {
  background-color: #ffffff;
}

#app .v-time-picker-clock__item + span {
  font-size: $font-size-sm;
  font-weight: bold;
}

#app input::placeholder {
  color: #707070;
}

#app .v-label {
  color: #000000;
}

#app .v-label--is-disabled {
  color: #707070;
}

#app .v-messages__message {
  font-size: 1rem;
  line-height: 1.25em;
}

#app .v-text-field__details {
  padding-left: 0;
}

// #app .v-text-field.v-input > .v-input__control {
//   > .v-input__slot {
//     background-color: #f9f9f9 !important;
//     &:before {
//       border-color: #b7b7b7 !important;
//     }
//   }
// }

#app .theme--light.v-text-field--filled > .v-input__control > .v-input__slot {
  background: $light-gray;
}

#app
  .theme--light.v-text-field--filled:not(.v-input--is-focused)
  > .v-input__control
  > .v-input__slot:hover {
  background: $gray;
}

#app
  .theme--light.v-overflow-btn:not(.v-input--is-focused):not(.v-input--has-state)
  > .v-input__control
  > .v-input__slot:hover {
  background: rgba(0, 0, 0, 0.12);
}

#app .v-text-field.v-input--has-state > .v-input__control {
  > .v-input__slot {
    color: black !important;
    &:before {
      content: "" !important;
      border: 2px solid $purple !important;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }
    .v-select__slot {
      height: 55px;
      &:before {
        content: "" !important;
        border: 2px solid $purple !important;
        position: absolute;
        top: 0;
        left: -12px; // counteract 0 12px padding
        right: -12px; // counteract 0 12px padding
        bottom: -1px;
      }
    }
  }
}

#app .v-input__slot.error-state {
  border: 2px solid $purple;
  border-radius: 0;
}

.searchable-input {
  .v-input__slot {
    border-top: 0 !important;
    border-bottom-width: 1px !important;
    border-color: #818181 !important;
  }
}

#app .color-button {
  color: $black;
}

.create-a-timer {
  &__options {
    .v-input--selection-controls {
      margin-top: 0.25em;
    }
  }
  &__color {
    &--backdrop-transparent {
      color: #707070;
      .color-button__swatch {
        background: linear-gradient(
          45deg,
          #fff 47%,
          #e75678 47%,
          #e75678 53%,
          #fff 53%
        );
      }
    }
  }
}
</style>

<style lang="scss" scoped>
@import "../../styles/pages/_dashboard.scss";

.form-label {
  font-weight: bold;
  font-size: 1em;
  border: none;
  padding: 0;
  line-height: 1;
  margin-bottom: 1em;
  display: block;
}
.page-wrapper {
  // padding: 40px 0;
  background: #fff;
  @include for-size(desktop-up) {
    // padding: 40px 50px;
  }
}
.create-a-timer {
  &__heading-wrapper {
    padding-top: 1.5em;
    padding-left: 30px;
    @include for-size(tablet-up) {
      padding-top: 2.5em;
      padding-left: 50px;
    }
    @include for-size(tablet-landscape-up) {
      padding-top: 3.5em;
    }
    @include for-size(desktop-up) {
      margin-left: 0;
      padding-left: 0;
    }
  }
  &__submit-button-wrapper {
    padding-left: 29px;
    padding-right: 29px;
    padding-bottom: 45px;
    @include for-size(tablet-up) {
      padding-left: 0;
      padding-bottom: 41px;
      padding-right: 51px;
    }
    @include for-size(desktop-up) {
      margin-right: 40px;
      padding-right: 6px;
      padding-bottom: 98px;
    }
  }
  &__submit-button {
    width: 424px;
    max-width: 100%;
  }
  &__column-wrap {
    display: flex;
    flex-direction: column;
    width: 100%;
    @include for-size(tablet-up) {
      display: block;
      position: relative;
    }
    @include for-size(tablet-landscape-up) {
      padding-right: 40px;
    }
    @include for-size(desktop-up) {
      display: flex;
      flex-wrap: nowrap;
      flex-direction: row;
      justify-content: space-between;
      margin-right: 90px;
    }
  }
  &__column {
    padding-top: 2.25em;
    @include for-size(tablet-up) {
      &--colors {
        min-width: 225px;
      }
    }
    @include for-size(tablet-landscape-up) {
      max-width: 228px;
      &--colors {
        margin-right: 0;
        right: 0;
        left: 50%;
        position: absolute;
        top: 0;
      }
    }
    @include for-size(desktop-up) {
      &--colors {
        position: static;
      }
      margin-right: 50px;
      &:last-child {
        margin-right: 0;
      }
    }
  }
  &__design {
    width: 100%;
    @include for-size(tablet-up) {
      width: 35%;
    }
    @include for-size(tablet-landscape-up) {
      width: 50%;
    }
    @include for-size(desktop-up) {
      width: 60%;
      padding-top: 2.4em;
    }
  }
  &__selection-area {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    @include for-size(tablet-up) {
      max-width: 228px;
    }

    &--fonts {
      margin-bottom: 1em;
    }
  }
  &__item-wrap {
    position: relative;
    margin-bottom: 8px;
    flex: 1 0 45%;
    &:nth-child(odd) {
      margin-right: 8px;
    }
    input {
      position: absolute;
      left: 0;
      top: 0;
      opacity: 0;
      &:checked {
        & + label {
          border-color: #6a6a6a;
          border-width: 2px;
          svg {
            fill: #000;
          }
        }
      }
    }
  }
  &__colors {
    display: flex;
    justify-content: space-between;
    max-width: 300px;
    @include for-size(tablet-up) {
      max-width: 210px;
    }
  }
  &__color {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  &__options {
    margin-top: 3em;
  }
  &__button {
    display: flex;
    cursor: pointer;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 70px;
    border: 1px solid #e3e2e2;
    border-radius: 10px;
    &:hover {
      border-width: 2px;
      border-color: #707070;
    }
    svg {
      display: block;
      fill: #000000;
      width: 80px;
      max-height: 20px;
    }

    &--gray svg {
      fill: #aeaeae;
    }
  }

  &__preview {
    &--top {
      position: sticky;
      top: 0;
      width: 100%;
      border-radius: 0;
      border: 1px solid $gray;
      z-index: 2;
      @include for-size(tablet-up) {
        position: relative;
      }
      @include visible(desktop-down, flex);
    }
    &--right {
      display: flex;
      @include visible(desktop-up, flex);
    }
    background: red url("../../assets/images/checkered.png");
    background-position: -5px -5px;
    background-size: 25px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #f1f1f1;
    border-radius: 10px;
    padding: 0 0.5em;
    min-height: 129px;
    width: 100%;
    @include for-size(tablet-up) {
      padding: 0 1.25em;
      min-height: 225px;
    }
    @include for-size(desktop-up) {
      margin-right: 0;
    }
  }
  &__wrapper {
    display: flex;
    flex-wrap: wrap;
    border-bottom: 1px solid #ebebeb;
    @include for-size(desktop-up) {
      flex-wrap: nowrap;
    }
  }
  &__padding-wrapper {
    padding-right: 29px;
    padding-left: 29px;
    @include for-size(tablet-up) {
      padding-left: 0;
      padding-right: 0;
    }
    &--right {
      @include for-size(tablet-up) {
        padding-right: 60px;
      }
      @include for-size(tablet-landscape-up) {
        padding-right: 0;
      }
    }
  }
  &__details {
    width: 100%;
    padding-top: 2.25em;
    @include for-size(tablet-up) {
      max-width: 59%;
      padding-right: 44px;
      margin-right: 44px;
      padding-left: 50px;
      box-sizing: border-box;
      border-right: 1px solid #ebebeb;
    }
    @include for-size(tablet-landscape-up) {
      max-width: 42%;
      padding-right: 40px;
      padding-left: 50px;
      margin-right: 40px;
      padding-bottom: 1.5em;
    }
    @include for-size(desktop-up) {
      max-width: 33%;
      width: 33%;
      margin-right: 48px;
      padding-right: 48px;
      padding-top: 2.4em;
    }
  }
  @include for-size(tablet-up) {
    &__wrapper {
      display: flex;
    }
  }

  &__heading {
    margin-bottom: 1em;
    @include visible(desktop-up);
    &--top {
      @include visible(desktop-down);
    }
  }

  &__font-options {
    display: flex;
    flex: 1;
    justify-content: space-between;
    align-items: center;

    svg {
      padding-left: 0.5em;
      height: 1em;
    }
  }
}
</style>
